module.exports = __webpack_public_path__ + "img/mannul_news_add-1.5f281d7f.png";